export const prices = [
  {
    id: 0,
    name: "Any",
    array: []
  },
  {
    id: 1,
    name: "$0 to $19",
    array: [ 0, 19 ]
  },
  {
    id: 2,
    name: "$20 to $39",
    array: [ 20, 39 ]
  },
  {
    id: 3,
    name: "$40 to $59",
    array: [ 40, 59 ]
  },
  {
    id: 4,
    name: "$60 to $79",
    array: [ 60, 79 ]
  },
  {
    id: 5,
    name: "More than $80",
    array: [ 80, 999 ]
  },

];